import wrong1 from "./wrong1.mp3";
import wrong2 from "./wrong2.mp3";
import wrong3 from "./wrong3.mp3";
const wrong = [wrong1, wrong2, wrong3];
export default wrong;
